import { useCallback, useEffect, useState } from 'react';

/** Предзагрузка по полному временному URL из ответа бэкенда без изменения подписи. */
export async function prefetchAuthenticatedImage(resourceUrl: string | null | undefined): Promise<void> {
  if (!resourceUrl) return;
  await new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = resourceUrl;
  });
}

/**
 * screen_url передаётся в img без изменения. Временные ссылки не сохраняются в кэше приложения.
 * Имена функции и blobUrl оставлены для совместимости с компонентами просмотра.
 */
export function useAuthenticatedBlobUrl(resourceUrl: string | null, enabled = true) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const blobUrl = enabled ? resourceUrl : null;

  useEffect(() => {
    setFailedUrl(null);
  }, [resourceUrl, enabled]);

  const onImageError = useCallback(() => setFailedUrl(resourceUrl), [resourceUrl]);
  return { blobUrl, loading: false, error: !!blobUrl && failedUrl === blobUrl, onImageError };
}
